import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "table table-sm table-borderless table-list table-form" }
const _hoisted_2 = {
  class: "font-s-14",
  colspan: "2"
}
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-plus mr-1" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6 mb-1" }
const _hoisted_7 = {
  key: 0,
  class: "form-check mt-2"
}
const _hoisted_8 = ["onUpdate:modelValue", "data-fieldname", "name", "id", "required"]
const _hoisted_9 = ["for"]
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_11 = ["for"]
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = ["onUpdate:modelValue", "name", "id", "required"]
const _hoisted_14 = ["onUpdate:modelValue", "data-fieldname", "name", "id", "required"]
const _hoisted_15 = ["onUpdate:modelValue", "name", "id", "required"]
const _hoisted_16 = { style: {"width":"100px"} }
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = ["onClick", "data-row-name"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-times" }, null, -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString($props.title) + " ", 1 /* TEXT */),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.add_details_row && $options.add_details_row(...args))),
              class: "btn btn-sm btn-outline-dark ms-auto",
              style: {"padding":"0 6px"}
            }, [
              _hoisted_4,
              _createTextVNode(" New")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, (row) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: row.name
        }, [
          _createCommentVNode("        <slot :row=\"row\"/>"),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, (field) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (field.fieldtype==='Check')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input form-check-input-lg",
                          "onUpdate:modelValue": $event => ((row[field.fieldname]) = $event),
                          "data-fieldname": field.fieldname,
                          name: `${$props.tableName}_${field.fieldname}`,
                          id: `${$props.tableName}-${field.fieldname}-${row.name}`,
                          required: field.reqd,
                          "true-value": 1,
                          "false-value": 0
                        }, null, 8 /* PROPS */, _hoisted_8), [
                          [_vModelCheckbox, row[field.fieldname]]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label form-check-label-lg",
                          for: `${$props.tableName}-${field.fieldname}-${row.name}`
                        }, [
                          _createTextVNode(_toDisplayString(field.label) + " ", 1 /* TEXT */),
                          (field.reqd)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "*"))
                            : _createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_9)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (field.fieldtype!=='Check')
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 1,
                        class: "control-label",
                        for: `${$props.tableName}-${field.fieldname}-${row.name}`
                      }, [
                        _createTextVNode(_toDisplayString(field.label) + " ", 1 /* TEXT */),
                        (field.reqd)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "*"))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_11))
                    : _createCommentVNode("v-if", true),
                  (field.fieldtype==='Data')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 2,
                        type: "text",
                        class: "form-control form-control-xs",
                        "onUpdate:modelValue": $event => ((row[field.fieldname]) = $event),
                        name: `${$props.tableName}_${field.fieldname}`,
                        id: `${$props.tableName}-${field.fieldname}-${row.name}`,
                        required: field.reqd,
                        autocomplete: "off"
                      }, null, 8 /* PROPS */, _hoisted_13)), [
                        [_vModelText, row[field.fieldname]]
                      ])
                    : _createCommentVNode("v-if", true),
                  (field.fieldtype==='Date')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 3,
                        type: "text",
                        class: "form-control form-control-xs",
                        "onUpdate:modelValue": $event => ((row[field.fieldname]) = $event),
                        "data-fieldname": field.fieldname,
                        "data-toggle": "datepicker",
                        name: `${$props.tableName}_${field.fieldname}`,
                        id: `${$props.tableName}-${field.fieldname}-${row.name}`,
                        required: field.reqd,
                        autocomplete: "off"
                      }, null, 8 /* PROPS */, _hoisted_14)), [
                        [_vModelText, row[field.fieldname]]
                      ])
                    : _createCommentVNode("v-if", true),
                  (field.fieldtype==='Small Text')
                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                        key: 4,
                        class: "form-control form-control-xs",
                        "onUpdate:modelValue": $event => ((row[field.fieldname]) = $event),
                        rows: "4",
                        name: `${$props.tableName}_${field.fieldname}`,
                        id: `${$props.tableName}-${field.fieldname}-${row.name}`,
                        required: field.reqd
                      }, null, 8 /* PROPS */, _hoisted_15)), [
                        [_vModelText, row[field.fieldname]]
                      ])
                    : _createCommentVNode("v-if", true)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]),
          _createElementVNode("td", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-danger",
                onClick: $event => ($options.remove_details_row(row.name,$props.data)),
                "data-row-name": row.name,
                style: {"width":"40px","padding":"2px 10px"},
                tooltip: "Delete"
              }, _hoisted_20, 8 /* PROPS */, _hoisted_18)
            ])
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}